import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KnHint = _resolveComponent("KnHint")
  const _component_Badge = _resolveComponent("Badge")
  const _component_DetailsCard = _resolveComponent("DetailsCard")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_RolesCard = _resolveComponent("RolesCard")
  const _component_ConstraintsCard = _resolveComponent("ConstraintsCard")
  const _component_TabView = _resolveComponent("TabView")

  return (!_ctx.selectedMode.useID)
    ? (_openBlock(), _createBlock(_component_KnHint, {
        key: 0,
        class: "kn-card-reset",
        title: 'managers.driversManagement.useModes.title',
        hint: 'managers.driversManagement.useModes.hint',
        "data-test": "mode-hint"
      }, null, 8, ["title", "hint"]))
    : (_openBlock(), _createBlock(_component_TabView, {
        key: 1,
        class: "tabview-custom kn-page-content",
        "data-test": "modes-form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('managers.driversManagement.useModes.details')), 1),
              (_ctx.invalidModes > 0)
                ? (_openBlock(), _createBlock(_component_Badge, {
                    key: 0,
                    value: _ctx.invalidModes,
                    class: "p-ml-2",
                    severity: "danger"
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_DetailsCard, {
                selectedMode: _ctx.mode,
                selectionTypes: _ctx.selectionTypes,
                layers: _ctx.layers,
                isDate: _ctx.isDate,
                lovs: _ctx.lovs,
                showMapDriver: _ctx.showMapDriver
              }, null, 8, ["selectedMode", "selectionTypes", "layers", "isDate", "lovs", "showMapDriver"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('managers.driversManagement.useModes.roles')), 1),
              (_ctx.invalidRoles)
                ? (_openBlock(), _createBlock(_component_Badge, {
                    key: 0,
                    value: "1",
                    class: "p-ml-2",
                    severity: "danger"
                  }))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_RolesCard, {
                roles: _ctx.availableRoles,
                selectedModeProp: _ctx.mode
              }, null, 8, ["roles", "selectedModeProp"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('managers.driversManagement.useModes.constraints')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_ConstraintsCard, {
                constraints: _ctx.constraints,
                selectedModeProp: _ctx.mode
              }, null, 8, ["constraints", "selectedModeProp"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
}